import {useContext} from "react";
import {FavoritesContext} from "../Providers/FavoritesContext";
import ItemType from "../../Models/ItemType";

const useFavorites = (itemType?: ItemType, id?: string) => {

    let favorites: any = useContext(FavoritesContext);
    let returnedFavorites;
    if (favorites && itemType) {
        switch (itemType as ItemType) {
            case ItemType.Employee:
                if (favorites.Employees)
                    returnedFavorites = id ? favorites.Employees[id] : favorites.Employees;
                break;
            case ItemType.QuickLink:
                if (favorites["Quick Links"])
                    returnedFavorites = id ? favorites["Quick Links"][id] : favorites["Quick Links"];
                break;
            case ItemType.Event:
                if (favorites.Events)
                    returnedFavorites = id ? favorites.Events[id] : favorites.Events;
                break;

        }
    }

    return favorites ?? {};
};

export default useFavorites;